//Orders FlexiGrid

//React & Friends
import React, { useState, useEffect, useContext, useRef } from 'react';
import FlexiGrid from '../common/FlexiGrid/FlexiGrid';

//Doublecheck everything below this line. All from old boilerplate table.
import { useLocation, useHistory } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';

//Contexts
import { AppContext } from "../Auth/contexts/AppContext"

//CSS Styles
import flexstyles from '../../css/FlexCss';
import useClasses from '../../ui/useClasses';

//Datetime formatting
import dayjs from 'dayjs'; //Used with new datetimepickers

//MaterialUI
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';

//NNNNNNNNNNNNN-NON-STANDARD IMPORTS-SSSSSS-SSS
//Additional Libraries Specific to Orders FlexiGrid
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import MarketIcon from "../common/MarketIcon";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Typography } from '@mui/material';

//PAS Icons
import pstatus1 from '../images/Pstatus1.png';
//import pstatus2 from '../images/Pstatus2.png'; Unused.
import pstatus3 from '../images/Pstatus3.png';
import sstatus1 from '../images/Sstatus1.png';
//import sstatus2 from '../images/Sstatus2.png'; Unused
import sstatus3 from '../images/Sstatus3.png';
import astatus1 from '../images/Astatus1.png';
import astatus2 from '../images/Astatus2.png';
import astatus3 from '../images/Astatus3.png';
import astatus4 from '../images/Astatus4.png';

//Import OrdersView Component
import OrdersView from "./OrdersView";

//Functional Controller
const OrdersFlexiGrid = () => {
	/* CSS and Media Queries */
	const classes = useClasses(flexstyles);

	/* App Context - Allows userPerms, userRole, and others to be used*/
	const appContext = useContext(AppContext);
	const { userPerms, userRole } = appContext;

	/* ##########################  DATA MUTATION  ########################## */
	//   This function allows us to mutate data after it is received from the database, but before it is rendered on the grid or exported.
	const MutateData = (dbdata) => {
		//Mutate each item in dbdata as needed.
		var totaltax = 0;
		for (var i=0; i<dbdata.length; i++){
			// //Example: Add Margin calculation
			// dbdata[i]["NewMargin"] = (parseFloat(dbdata[i]["Price"]) - parseFloat(dbdata[i]["Cost"])).toFixed(2);
			//Setup Name:
			if (dbdata[i]["SFullName"]){
				dbdata[i]["Name"] = dbdata[i]["SFullName"];
			} else if (!dbdata[i]["SFullName"] && dbdata[i]["SFirstName"]){
				dbdata[i]["Name"] = (dbdata[i]["SFirstName"] ? dbdata[i]["SFirstName"] : "") + " " + (dbdata[i]["SLastName"] ? dbdata[i]["SLastName"] : "");
			} else if (!dbdata[i]["SFullName"] && !dbdata[i]["SFirstName"]){
				if (!dbdata[i]["BFullName"] && dbdata[i]["BFirstName"]){
					dbdata[i]["Name"] = (dbdata[i]["BFirstName"] ? dbdata[i]["BFirstName"] : "") + " " + (dbdata[i]["BLastName"] ? dbdata[i]["BLastName"] : "");
				} else {
					dbdata[i]["Name"] = dbdata[i]["BFullName"] ? dbdata[i]["BFullName"] : "Unknown Name";
				}
			}

			//Total Tax
			totaltax=0;
			for (var j=0; j<dbdata[i].charges.length; j++){
				if (dbdata[i].charges[j].ChargeType==="tax"){
					totaltax += parseFloat(dbdata[i].charges[j].Amount);
				}
			}
			dbdata[i]["TaxTotal"] = totaltax.toFixed(2);

		}
		return dbdata;
	}
	//Data used for Expanded Export
	const ExportMutateData = (dbdata) => {
		//console.log("$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$");
		console.log(dbdata.length);
		var newexportdata = [];
		var newrecord = [];
		var productname="";
		//Mutate each item in dbdata as needed.
		for (var i=0; i<dbdata.length; i++){
			//Example: Add Margin calculation
			dbdata[i]["NewNewMargin"] = 500; //(parseFloat(dbdata[i]["Price"]) - parseFloat(dbdata[i]["Cost"])+500).toFixed(2);


			if (dbdata[i].hasOwnProperty('validorderitems')){
				if (dbdata[i]['validorderitems']!==null && dbdata[i]['validorderitems']!==undefined){
					for (var j=0; j<dbdata[i]['validorderitems'].length; j++){
						//console.log("++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++");
						newrecord = { ...dbdata[i] }; 
						newrecord['Quantity'] = dbdata[i]['validorderitems'][j]['Quantity'];
						newrecord['Sku'] = dbdata[i]['validorderitems'][j]['Code'];

						productname = String(dbdata[i]['validorderitems'][j]['ProductName']);
						if (/[",\n]/.test(productname)) {
							// Double the double quotes
							newrecord['ProductName'] = productname.replace(/"/g, '""');
						} else {
							newrecord['ProductName'] = dbdata[i]['validorderitems'][j]['ProductName'];
						}
						newrecord['TotalPrice'] = dbdata[i]['validorderitems'][j]['TotalPrice'];
						newexportdata.push(newrecord);
					}
				}
			} else {
				//Do nothing, this order won't have any order items!
			}
		}
		return newexportdata;
	}

	/* ##########################  Expanded Row Render  ########################## */
	//   This controls how an expanded row is rendered on ExpandRow=true! Enable expanded row with configuration.expandedrow = true.
	//   This functional component will be different for each table's need!
	const ExpandedRowRender = ({ localstate, index, classes, UpdateState }) => {
		const CopyContent = (content) => {
			navigator.clipboard.writeText(content);
		}
		//Expanded row is rendered just inside <tr><tr>
		//With access to index, localstate, and UpdateState, you can make this to powerful things!
		return (
			<>
				<td style={{ backgroundColor: "#FFF", border: "1px solid #BBB", borderTop: "0px" }}>

				</td>
				<td colSpan={localstate.configuration.columns.filter(col => col.visible).length - 1} style={{ backgroundColor: "#F9F9F9", borderTop: "0px", padding: "10px 15px 10px 15px", maxWidth: "100%" }}>
					<Grid container spacing={2} sx={{ fontSize: "14px" }}>
						<Grid size={{ xs: 12, md: 6, lg: 3 }}>
							<span style={{ fontWeight: "bold", fontSize: "14px" }}>Billing:</span><br></br>
							<span style={{ fontWeight: "normal", fontSize: "14px" }}>
								{/** Apply First/Last if Full Name isn't truthy. */}
								{(!localstate.griditems[index]['BFullName']) &&
									<>
										{localstate.griditems[index]['BFirstName']} {localstate.griditems[index]['BLastName']}<br></br>
									</>
								}
								{/** Apply Full Name if truthy. */}
								{(localstate.griditems[index]['BFullName']) &&
									<>
										{localstate.griditems[index]['BFullName']}<br></br>
									</>
								}
								{localstate.griditems[index]['BLine1']}<br></br>
								{localstate.griditems[index]['BCity']}{(localstate.griditems[index]['BCity'] ? "," : "")} {localstate.griditems[index]['BStateCode']} {(localstate.griditems[index]['BPostalCode'] ? localstate.griditems[index]['BPostalCode'].substring(0, 5) : "")}

								<br></br>
							</span>
						</Grid>
						<Grid size={{ xs: 12, md: 6, lg: 3 }}>
							<span style={{ fontWeight: "bold", fontSize: "14px" }}>Shipping:</span><br></br>
							<span style={{ fontWeight: "normal", fontSize: "14px" }}>
								{/** Apply First/Last if Full Name isn't truthy. */}
								{(!localstate.griditems[index]['SFullName']) &&
									<>
										{localstate.griditems[index]['SFirstName']} {localstate.griditems[index]['SLastName']}<br></br>
									</>
								}
								{/** Apply Full Name if truthy. */}
								{(localstate.griditems[index]['SFullName']) &&
									<>
										{localstate.griditems[index]['SFullName']}<br></br>
									</>
								}
								{localstate.griditems[index]['SLine1']}<br></br>
								{localstate.griditems[index]['SCity']}{(localstate.griditems[index]['SCity'] ? "," : "")} {localstate.griditems[index]['SStateCode']} {(localstate.griditems[index]['SPostalCode'] ? localstate.griditems[index]['SPostalCode'].substring(0, 5) : "")}

								<br></br>
							</span>
						</Grid>

						{(localstate.griditems[index]['validorderitems'].length > 0) &&
							<Grid size={{ xs: 12, md: 12, lg: 6 }} sx={{ maxWidth: "100%" }}>
								<div style={{ fontWeight: "bold", borderBottom: "1px solid #CCC" }}>Items:</div>
								{localstate.griditems[index]['validorderitems'].map((orderitem, orderitemindex) => {
									//Avoid render of first item already rendered.
									return (
										<div key={"orderitem" + orderitemindex} style={{ marginBottom: "8px", display: "block" }}>
											<div className={classes.truncatedtext2line}>
												<b>({orderitem.Quantity})</b>&nbsp;<span title={orderitem.ProductName}>{orderitem.ProductName}</span>
											</div>

											<Grid container sx={{ borderBottom: "1px solid #CCC" }}>
												<Grid size={{ xs: 9, sm: 10, md: 10 }}>
													<div className={classes.truncatedtext1line}>
														<b>SKU:</b> {orderitem.Code}&nbsp;
														<ContentCopyIcon
															className={classes.hoverunitanimated}
															style={{ fontSize: "14px", color: "#4183c4", cursor: "pointer", verticalAlign: "middle" }}
															onClick={() => CopyContent(orderitem.Code)}
														/>
													</div>
												</Grid>

												<Grid size={{ xs: 3, sm: 2, md: 2 }} sx={{ textAlign: "right" }}>
													<b>${orderitem.TotalPrice}</b>
												</Grid>
											</Grid>



											{/* <div style={{borderBottom:"1px solid #CCC"}}>
													<div className={classes.truncatedtext1line}  style={{width:"90%", display:"inline-block"}}>
														&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
														Sku: {orderitem.Code}&nbsp;
														<ContentCopyIcon
															className={classes.hoverunitanimated}
															style={{ fontSize: "14px", color: "#4183c4", cursor: "pointer", verticalAlign: "middle" }}
															onClick={() => CopyContent(orderitem.Code)}
														/>
													</div>
													<div style={{width:"10%", display:"inline-block", verticalAlign:"top"}}>
														<b>{orderitem.TotalPrice}</b>
													</div>
												</div> */}
										</div>
									)
								})
								}

								<Grid container>
									<Grid size={{ xs: 9, sm: 10, md: 10 }} sx={{ fontWeight: "bold" }}>
										Order Total:<br></br>
										<span style={{ fontWeight: "normal", fontSize: "10px" }}>* Includes taxes and fees.</span>
									</Grid>

									<Grid size={{ xs: 3, sm: 2, md: 2 }} sx={{ textAlign: "right" }}>
										<b>${localstate.griditems[index].Total}</b>
									</Grid>
								</Grid>

							</Grid>
						}
					</Grid>
				</td>
			</>

		)
	}

	/* ##########################  CUSTOM FUNCTIONS  ########################## */
	const CustomPriceRender = ({ localstate, index, column, classes, UpdateState, ExpandRowToggle }) => {
		return (
			<td
				style={column.cellstyle}
				className={classes.flexigridcustomcontainer}
			>
				<div style={{ fontWeight: "bold", color: "blue" }} onClick={() => ExpandRowToggle(index)}>
					{localstate.griditems[index]["Price"]}
				</div>
			</td>
		);
	};

	const customNameElement = ({ localstate, index, column, classes, UpdateState, ExpandRowToggle }) => {
		return (
			<td
				style={column.cellstyle}
				className={classes.flexigridtextcontainer}
			>
				<div className={classes.truncatedtextcontainer} style={{ cursor: "pointer" }} onClick={() => ExpandRowToggle(index)}>
					<div className={classes.truncatedtext}>
					<>{localstate.griditems[index]['Name']}</>
						{/* {(localstate.griditems[index]['SFullName']) &&
							<>{localstate.griditems[index]['SFullName']}</>
						}
						{(!localstate.griditems[index]['SFullName'] && localstate.griditems[index]['SFirstName']) &&
							<>{localstate.griditems[index]['SFirstName']} {localstate.griditems[index]['SLastName']}</>
						}
						{(!localstate.griditems[index]['SFullName'] && !localstate.griditems[index]['SFirstName']) &&
							<>{localstate.griditems[index]['BFirstName']} {localstate.griditems[index]['BLastName']}</>
						} */}

					</div>
				</div>
			</td>

		);
	};

	const customItemsElement = ({ localstate, index, column, classes, UpdateState, ExpandRowToggle, ResetKeys }) => {
		return (
			<td
				style={column.cellstyle}
				className={classes.flexigridtextcontainer}
			>

				{(localstate.griditems[index]['validorderitems'].length > 0) &&
					<div style={{ cursor: "pointer" }} onClick={() => ExpandRowToggle(index)}>
						<div className={classes.truncatedtextcontainer} style={{
							display: "inline-block",
							width: (localstate.griditems[index]['validorderitems'].length > 1) ? "calc(100% - 30px)" : "100%",
							verticalAlign: "top"
						}}>
							<div className={classes.truncatedtext}>
								<b>({localstate.griditems[index]['validorderitems'][0].Quantity})</b> {localstate.griditems[index]['validorderitems'][0].ProductName}
									{(localstate.griditems[index]['validorderitems'][0].sku) &&
										<>
											{(localstate.griditems[index]['validorderitems'][0].sku['Configured']===0) &&
												<span style={{color:"orange", fontSize:"12px", display:"inline-block", marginBottom:"2px"}}>&nbsp;&nbsp;Not Configured</span>
											}
										</>
									}
							</div>
						</div>
						{(localstate.griditems[index]['validorderitems'].length > 1) &&
							<div style={{ display: "inline-block", width: "30px" }}>
								<span style={{ color: "#4183c4", fontWeight: "bold" }}>&nbsp; + {localstate.griditems[index]['validorderitems'].length - 1}</span>
							</div>
						}
					</div>

				}
			</td>

		);
	};

	const BulkMutatorBtn = ({ localstate, index, column, classes, UpdateState }) => {
		const ApplyBulkMutation = (localstate, UpdateState) => {
			for (var i = 0; i < localstate.griditems.length; i++) {
				localstate.griditems[i].Price = 666; //Or do some calculation based the current griditems values. 
			}
			UpdateState(localstate);
		}
		return (
			<td
				style={column.cellstyle}
				className={classes.flexigridcustomcontainer}
			>
				<span style={{ fontWeight: "bold", color: "blue" }}>
					<Button
						className={classes.bluebtn}
						style={{ margin: "0px", padding: "3px 3px 2px 3px" }}
						color="primary" variant="contained"
						onClick={() => ApplyBulkMutation(localstate, UpdateState)}>
						Bulk Mutate Price
					</Button>
				</span>
			</td>
		);
	};


	const SelectUnprinted = ({localstate, UpdateState, dispatch, newStatus, setStatusTimeout}) =>{
		var count = 0;
		for (var i=0; i<localstate.griditems.length; i++){
			if (localstate.griditems[i].PrintStatus===0 && localstate.griditems[i].isSelected!==true){
				//Select the Row:
				localstate.selectedindexes.push(i);
				localstate.griditems[i].isSelected = true;
				count++;
			}
		}
		dispatch(newStatus({
			type: "itemsselected",
			msg: count+' items added to selection.',
			show: true
		}));
		//dispatch(newStatus({ errmsg: "No items selected.", errshow: true, errtimeout: 5, errtype: 'neutral' }));
		dispatch(setStatusTimeout(4000));
		UpdateState(localstate);
	}

	const ViewSelectedWorksheets = ({localstate, UpdateState, dispatch, newStatus, setStatusTimeout}) =>{
		//RejectIfInvalidSelected("worksheet", OpenOrders)
		OpenOrders(localstate, UpdateState, "worksheet");





	} 


	const OpenOrders = (localstate, UpdateState, viewmode) => {
		var itemids = [];
		//Grab all IDs
		for (var i = 0; i < localstate.selectedindexes.length; i++) {
			itemids.push(localstate.griditems[localstate.selectedindexes[i]]['InternalID']);
		}
		localstate.currentids = itemids;
		localstate.configuration.viewmode = viewmode;
		localstate.orderview = true;
		UpdateState(localstate);
		console.log(localstate.currentids);
		//localStorage.setItem("ordersarray", JSON.stringify(itemids));
		//window.open(viewtype, "_blank");
	}


	const MktIcon = ({ localstate, index, column, classes, UpdateState }) => {
		return (
			<td
				style={column.cellstyle}
				className={classes.flexigridcustomcontainer}
			>
				<MarketIcon height="20px" storename={localstate.griditems[index]['Store']} verticalalignment="bottom" />
			</td>

		);
	};

	const PASStatusRender = ({ localstate, index, column, classes, UpdateState, ExpandRowToggle, ResetKeys }) => {
		// const ApplyBulkMutation = (localstate, UpdateState) => {
		// 	for (var i = 0; i < localstate.griditems.length; i++) {
		// 		localstate.griditems[i].Price = 666; //Or do some calculation based the current griditems values. 
		// 	}
		// 	UpdateState(localstate);
		// }

		const ShowPrintedDate = (printdate) => {
			console.log(printdate);
			console.log(localstate);
			localstate.searchoptions.searchpairs.searchpair1 = localstate.configuration.configuredinputs[1]; 
			localstate.searchoptions.searchpairs.searchpair2 = localstate.configuration.configuredinputs[2]; 
			localstate.searchoptions.searchpairs.searchpair3 = localstate.configuration.configuredinputs[3]; 
			localstate.searchoptions.searchpairs.searchpair4 = localstate.configuration.configuredinputs[4]; 
			localstate.searchoptions.searchpairs.searchpair5 = localstate.configuration.configuredinputs[5]; 
			localstate.searchoptions.searchpairs.searchpair6 = localstate.configuration.configuredinputs[6]; 
			localstate.searchoptions.searchpairs.searchpair7 = localstate.configuration.configuredinputs[7]; 
			localstate.searchoptions.searchpairs.searchpair8 = localstate.configuration.configuredinputs[8]; 

			//Set Printed Date Search:
			localstate.searchoptions.searchpairs.searchpair2 = inputdefaults.PrintedDate;
			localstate.searchoptions.searchpairs.searchpair2.value=printdate;

			localstate.dbreload=true;
			UpdateState(localstate);

			// //Forcefully rerender search inputs!
			ResetKeys([], true);
		}


		return (
			<td
				style={column.cellstyle}
				className={classes.flexigridcustomcontainer}
			>
				<div style={{ padding: "3px" }}>
					{(localstate.griditems[index]['Canceled'] === 1) &&
						<React.Fragment>
							Canceled
						</React.Fragment>
					}

					{(localstate.griditems[index]['Canceled'] === 0) &&
						<React.Fragment>
							{(localstate.griditems[index]['PrintStatus'] === 0) &&
								<img style={{ height: "25px", marginLeft: "5px" }} src={pstatus1} />
							}
							{(localstate.griditems[index]['PrintStatus'] === 2) &&
								<a onClick={() => { ShowPrintedDate(localstate.griditems[index]['PrintedDate']) }} className={classes.hoverunit}>
									<img style={{ height: "25px", marginLeft: "5px" }} src={pstatus3} />
								</a>
							}

							{/*
								0: no asset
								1: Under Capacity
								2: Normal Fulfilled
								4: Over capacity
							*/}
							{(localstate.griditems[index]['AssetStatus'] === 0) &&
								<img style={{ height: "25px", marginLeft: "5px" }} src={astatus1} />
							}
							{(localstate.griditems[index]['AssetStatus'] === 1) &&
								<a href={"/order/" + localstate.griditems[index]['InternalID']} target="_blank"><img style={{ height: "25px", marginLeft: "5px" }} src={astatus2} /></a>
							}

							{(localstate.griditems[index]['AssetStatus'] === 2) &&
								<a href={"/order/" + localstate.griditems[index]['InternalID']} target="_blank"><img style={{ height: "25px", marginLeft: "5px" }} src={astatus3} /></a>
							}
							{(localstate.griditems[index]['AssetStatus'] === 4) &&
								<a href={"/order/" + localstate.griditems[index]['InternalID']} target="_blank"><img style={{ height: "25px", marginLeft: "5px" }} src={astatus4} /></a>
							}



							{(localstate.griditems[index]['ShippedStatus'] === 0) &&
								<a href={"/order/" + localstate.griditems[index]['InternalID']} target="_blank"><img style={{ height: "25px", marginLeft: "5px" }} src={sstatus1} /></a>
							}
							{(localstate.griditems[index]['ShippedStatus'] === 2) &&
								<a href={"/order/" + localstate.griditems[index]['InternalID']} target="_blank"><img style={{ height: "25px", marginLeft: "5px" }} src={sstatus3} /></a>
							}
						</React.Fragment>

					}
				</div>
			</td>

			// 	<span style={{ fontWeight: "bold", color: "blue" }}>
			// 		<Button
			// 			className={classes.bluebtn}
			// 			style={{ margin: "0px", padding: "3px 3px 2px 3px" }}
			// 			color="primary" variant="contained"
			// 			onClick={() => ApplyBulkMutation(localstate, UpdateState)}>
			// 			Bulk Mutate Price
			// 		</Button>
			// 	</span>
			// </td>
		);
	};




	/* ##########################  CUSTOM ON-CHANGE FUNCTIONS  ########################## */
	//Custom for onChange of items in edit mode. See reference to this function in the Cost column. Bear in mind, Cost itself is handled with validation positivedecimal2
	const onChangeCost = ({ localstate, index, column, rowRefs }) => {
		rowRefs.current[index + "Margin"].textContent = localstate.griditems[index]["Margin"] = (parseFloat(localstate.griditems[index]["Price"]) - parseFloat(localstate.griditems[index]["Cost"])).toFixed(2);
	}

	/* ##########################  SEARCH INPUT DEFAULTS  ########################## */
	// These establish the baseline for the page search inputs.
	//Container and Key Sizes for Search Inputs
	const containersizes = "260px";
	const keysizes = "160px";

	//Input Defaults: Make sure you also have an entry in defaultselectinputs.
	var inputdefaults = {
		ordersquicksearch: {
			type: "ordersquicksearch",
			searchhandler:"ordersquicksearch",
			value: "",
			mode: "like", //For quicksearches, always leave 'like' here so that FlexiGridSearchTools can digest the data given. It will pass the search string with terms (string and spaces), to your function in CUSTOM DB SEARCHES section on FlexiGridController 
			orable: false,
			uuid: uuidv4(),
			container: containersizes,
			keysize: keysizes,
			grow: 1,
		},
		OrderID: {
			type: "OrderID",
			value: "",
			mode: "like",
			orable: false,
			uuid: uuidv4(),
			container: containersizes,
			keysize: keysizes,
			grow: 1,
		},
		ordersname: {
			type: "ordersname",
			searchhandler: "ordersname",
			value: "",
			mode: "like",
			orable: false,
			uuid: uuidv4(),
			container: containersizes,
			keysize: keysizes,
			grow: 1,
		},
		//Products AutoComplete - Autocompletes are always or-able
		products: {
			type: "products", //'products' is a known type in DBAutoComplete
			keyedby: "ProductID", //We'll need a key so that Autocomplete can highlight our value in the drop down after selection
			searchkey: "Name", //This is the column we are searching from the table
			searchhandler:"ordersproducts",
			value: [],
			multiple: true,
			//inputValue:"", //Text Search! This *CAN* be used... but seems nicer without it!
			mode: "autocomplete",
			orable: true, //Likely critical
			defaultsearchterm: "70",
			limit: 10, //Database return limit, keep below ~100
			uuid: uuidv4(),
			container: containersizes,
			keysize: keysizes,
			grow: 1,
			debouncetime: 0 //Not a lot of typing or results.
		},
		ordersproducttitle: {
			type: "ordersproducttitle",
			searchhandler: "ordersproducttitle",
			value: "",
			mode: "like",
			orable: false,
			uuid: uuidv4(),
			container: containersizes,
			keysize: keysizes,
			grow: 1,
		},
		orderssku: {
			type: "orderssku",
			searchhandler: "orderssku",
			value: "",
			mode: "like",
			orable: false,
			uuid: uuidv4(),
			container: containersizes,
			keysize: keysizes,
			grow: 1,
		},
		//Store (market) AutoComplete
		markets:{
			type:"markets",
			searchhandler: "ordersmarket",
			keyedby:"ID", //We'll need a key so that Autocomplete can highlight our value in the drop down after selection
			searchkey:"Name", //This is the column we are searching from the table
			value: [], 
			mode:"autocomplete",
			defaultsearchterm:"",
			limit:10, //Database return limit, keep below ~100
			uuid:uuidv4(),
			container:containersizes,
			keysize: keysizes,
			multiple:true,
			grow:1,
			debouncetime:0 //Not a lot of typing or results.
		},
		Address:{
			type:"Address",
			searchhandler: "ordersaddress",
			value:"",
			mode:"like",
			uuid:uuidv4(),		
			container:containersizes,
			keysize: keysizes,
			defaultvalue:"",
			grow:1,
		},
		City:{
			type:"City",
			searchhandler: "orderscity",
			value:"",
			mode:"like",
			uuid:uuidv4(),		
			container:containersizes,
			keysize: keysizes,
			defaultvalue:"",
			grow:1,
		},
		StateCode:{
			type:"StateCode",
			searchhandler: "ordersstate",
			value:"",
			mode:"like",
			uuid:uuidv4(),		
			container:containersizes,
			keysize: keysizes,
			defaultvalue:"",
			grow:1,
		},
		PostalCode:{
			type:"PostalCode",
			searchhandler: "orderspostalcode",
			value:"",
			mode:"like",
			uuid:uuidv4(),		
			container:containersizes,
			keysize: keysizes,
			defaultvalue:"",
			grow:1,
		},
		"Total >":{
			type:"Total >",
			value:"",
			mode:"greaterthan",
			uuid:uuidv4(),		
			container:containersizes,
			keysize: keysizes,
			defaultvalue:"",
			grow:1,
		},
		"Total <":{
			type:"Total <",
			value:"",
			mode:"lessthan",
			uuid:uuidv4(),		
			container:containersizes,
			keysize: keysizes,
			defaultvalue:"",
			grow:1,
		},
		OrderDateAfter:{
			type:"OrderDateAfter",
			value: (() => {
				//Set to 1 year ago
				return dayjs().subtract(1, 'year');
			})(),
			mode:"datetimeafter",
			uuid:uuidv4(),
			container:containersizes,
			keysize: keysizes,
			grow:1,
		},
		OrderDateBefore:{
			type:"OrderDateBefore",
			value: dayjs(), //new Date,
			mode:"datetimebefore",
			uuid:uuidv4(),
			container:containersizes,
			keysize: keysizes,
			grow:1,
		},
		PrintedDate:{
			type:"PrintedDate",
			value:"",
			mode:"exactdate",
			uuid:uuidv4(),		
			container:containersizes,
			keysize: keysizes,
			defaultvalue:"",
			grow:1,
		},
		Refunded:{
			type:"Refunded",
			value:"",
			mode:"bool",
			uuid:uuidv4(),		
			container:containersizes,
			keysize: keysizes,
			defaultvalue:"",
			grow:1,
		},
		Canceled:{
			type:"Canceled",
			value:"",
			mode:"bool",
			uuid:uuidv4(),		
			container:containersizes,
			keysize: keysizes,
			defaultvalue:"",
			grow:1,
		},
		PrintStatus:{
			//0 Not Printed, 2 Printed
			type:"PrintStatus",
			value:"",
			mode:"select",
			//Select Menu Items:
			menuitems:[
				{	
					value:"",
					key:uuidv4(),
					text:"Any",
					//Optional usechip - Overrides text
					usechip:true,
					chipsize:"small",
					chiplabel:"Any",
					chipclass:classes.gradeunknown,	
					//Optional Chip Height and Centering:
					height:"24px",
					center:true,
				},
				{	
					value:0,
					key:uuidv4(),
					text:"Not Printed",
					//Optional usechip - Overrides text
					usechip:true,
					chipsize:"small",
					chiplabel:"Not Printed",
					chipclass:classes.gradec,
					//Optional Chip Height and Centering:
					height:"24px",
					center:true,
				},
				{	
					value: 2,
					key:uuidv4(),
					text:"Printed",
					//Optional usechip - Overrides text
					usechip:true,
					chipsize:"small",
					chiplabel:"Printed",
					chipclass:classes.gradea, //Test this.		
					//Optional Chip Height and Centering:
					height:"24px",
					center:true,
				},
			],
			uuid:uuidv4(),
			container:containersizes,
			keysize: keysizes,
			//center:true,
			grow:1,
			usechips:true
		},
		AssetStatus:{
			type:"AssetStatus",
			value:[],
			mode:"select",
			//Select Menu Items:
			menuitems:[
				{	
					value:0,
					key:uuidv4(),
					text:"None",
					//Optional usechip - Overrides text
					usechip:true,
					chipsize:"small",
					chiplabel:"None",
					chipclass:classes.gradec, //Test this.		
					//Optional Chip Height and Centering:
					height:"24px",
					center:true,
				},
				{	
					value:1,
					key:uuidv4(),
					text:"Partial",
					//Optional usechip - Overrides text
					usechip:true,
					chipsize:"small",
					chiplabel:"Partial",
					chipclass:classes.gradeb, //Test this.		
					//Optional Chip Height and Centering:
					height:"24px",
					center:true,
				},
				{	
					value:2,
					key:uuidv4(),
					text:"Filled",
					//Optional usechip - Overrides text
					usechip:true,
					chipsize:"small",
					chiplabel:"Full",
					chipclass:classes.gradea, //Test this.		
					//Optional Chip Height and Centering:
					height:"24px",
					center:true,
				},
				{	
					value:4,
					key:uuidv4(),
					text:"Overfilled",
					//Optional usechip - Overrides text
					usechip:true,
					chipsize:"small",
					chiplabel:"Overfilled",
					chipclass:classes.gradebad, //Test this.		
					//Optional Chip Height and Centering:
					height:"24px",
					center:true,
				},
			],
			uuid:uuidv4(),
			container:containersizes,
			keysize: keysizes,
			//Experimental Multiple!
			multiple:true,//Change 'value' to array if true.
			//center:true,
			grow:1,
			usechips:true
		},
		ShippedStatus:{
			type:"ShippedStatus",
			value:"",
			mode:"select",
			//Select Menu Items:
			menuitems:[
				{	
					value:"",
					key:uuidv4(),
					text:"Any",
					//Optional usechip - Overrides text
					usechip:true,
					chipsize:"small",
					chiplabel:"Any",
					chipclass:classes.gradeunknown,	
					//Optional Chip Height and Centering:
					height:"24px",
					center:true,
				},
				{	
					value: 2,
					key:uuidv4(),
					text:"Shipped",
					//Optional usechip - Overrides text
					usechip:true,
					chipsize:"small",
					chiplabel:"Shipped",
					chipclass:classes.gradea, //Test this.		
					//Optional Chip Height and Centering:
					height:"24px",
					center:true,
				},
				{	
					value:0,
					key:uuidv4(),
					text:"Not Shipped",
					//Optional usechip - Overrides text
					usechip:true,
					chipsize:"small",
					chiplabel:"Not Shipped",
					chipclass:classes.gradec,
					//Optional Chip Height and Centering:
					height:"24px",
					center:true,
				},
			],
			uuid:uuidv4(),
			container:containersizes,
			keysize: keysizes,
			//Experimental Multiple!
			multiple:false,//Change 'value' to array if true.
			//center:true,
			grow:1,
			usechips:true
		}
	};

	/* ########################## Custom URL Parameters: Modify Per-Controller  ##########################

	 Each new table will likey have very different parameters. Handle them before configuration.

	Concept: We have this really complicated search input system. When a page is linked with URL parameters, let's marshall each 
	key-value pair into new defaults based on input defaults.

	Possibly clear the URL before rendering inputs and page?

				*/

	//This controls how many inputs we need to fill for the page. Typically 1 to 4, then up to 8 if there are a lot of drop down options necessary.
	const minimuminputs = 4;
	const maximuminputs = 8;





	const params = new URLSearchParams(useLocation().search);
	const urlparams = Array.from(params.entries());

	//		AUTOCOMPLETEPAIRS
	//		If you are not using auto-complete search inputs, you may simply comment the array inside autocompletepairs.
	// 		This is a special array. It is structured to allow a key-value pair shortcut to pre-fill a search input with label!
	//		Logic below also removes the need to add the search input type - when an autocomplete pair is found our custom array's third argument allows us to understand the search input type!
	//		Database compatibility: Autocompletes are typically driven by the searchinputtype as well, see DBAutoComplete.php
	// 		URL Params Compatiblity: Any link generator will need to follow the pattern of the autocompletepair. In this example, ProductID then Name and always in that order.
	// 
	// 
	// 		The structure of the array of arrays is:
	//		----------------------------------------------------------------------------------------------------------------------------------------------------------------------
	//		keyedby: "ProductID", //We'll need a key so that Autocomplete can highlight our value in the drop down after selection. This is often how the DB will load the items.
	//		searchkey: "Name", //This is the column we are searching from the table, often a friendly name
	//		searchinputtype:  The searchinput that we're pre-filling. Having this assigned means we won't ever need to reference it as a URL parameter!
	//		[[keyedby, searchkey, searchinputtype],[keyedby, searchkey, searchinputtype],...]


	const autocompletepairs = [
		['ProductID', 'Name', 'products'], //This will not only fetch from the DB correctly, but it will render the current search input value without a DB call!
		//More Entries...
	]

	const configuredinputs = []; //This is where we'll hold 
	var currentconfiguration = {}; 
	var combine = false;
	var simpleparam = true; //Values like OrderID, Name, Date.... no need for key-value input.
	//This itterates the parameters in sequential order. We need to have flags to check for pairs...
	for (let i = 0; i < urlparams.length; i++) {
		//Assume simpleparam until false:
		simpleparam = true;
		//console.log("Checking: "+urlparams[i][0]+"="+urlparams[i][1]);
		//With urlparams, 0 is the key, and 1 is the value.
		//Use current entry and check that it is or isn't an auto-complete pair
		for (let j=0; j<autocompletepairs.length; j++){
			if (urlparams[i][0]===autocompletepairs[j][0]){
				//Doublecheck for next value!
				if (urlparams[i+1] && urlparams[i+1][0]===autocompletepairs[j][1]){
					//console.log("Autocomplete Pair found: "+urlparams[i][0]+" and "+urlparams[i+1][0]);
					//Assume from here, we can digest the values and no longer process this as a simple parameter:
					simpleparam = false;
					currentconfiguration = Object.assign({}, inputdefaults[autocompletepairs[j][2]]); //Source must exist above. This example, we're cloning the 'products' search input.
					//This example is interpereted as : currentconfiguration = Object.assign({}, inputdefaults['products']);
					
					//Check if we should add our new configuration to an existing one.
					combine=false;
					for (var p=0;p<configuredinputs.length; p++){
						//console.log(configuredinputs);
						//console.log(currentconfiguration);
						if (configuredinputs[p].type===currentconfiguration.type){
							combine = true;
							//Modify existing configured input
							console.log("Check this1.");
							configuredinputs[p].value.push({
								[urlparams[i][0]]: urlparams[i][1],
								[urlparams[i + 1][0]]: urlparams[i + 1][1]
							})
						}
					}

					if (!combine){
						//Override value:
						currentconfiguration.value = [
							{
								[urlparams[i][0]]: urlparams[i][1],
								[urlparams[i + 1][0]]: urlparams[i + 1][1]
							}
						];
						//Push to configured inputs
						console.log("Check this2.");
						configuredinputs.push(currentconfiguration);
					}
					//console.log("Autocomplete found for: "+autocompletepairs[j][2]);
					//Since we consumed the second half of the URL parameter for the autocomplete, we skip the next URL entry!
					i++;
				}
			}
		}

		//If simpleparam is still true, we can handle it as a normal input:
		if (simpleparam){
			//Check that the parameter exists in inputdefaults:
			if (inputdefaults[urlparams[i][0]]){
				currentconfiguration = Object.assign({}, inputdefaults[urlparams[i][0]]);
				currentconfiguration.value = urlparams[i][1];
				console.log(currentconfiguration);
				//Push to configured inputs
				console.log("Check this3.");
				configuredinputs.push(currentconfiguration);
			}
		}
	}

	//console.log(configuredinputs);

	//If configured inputs is less than the minimum, we need to fill the remainder with appropriately available search inputs, preset to commonly used ones that aren't already specified in URL parameters!
	//First we'll need a search input priority array:
	var priorityarray = [
		"ordersquicksearch",
		"OrderID",
		"ordersname",
		"products",
		"ordersproducttitle",
		"orderssku",
		"markets",
		"Address",
		"City",
		"StateCode",
		"PostalCode",
		"Total >",
		"Total <",
		"OrderDateAfter",
		"OrderDateBefore",
		"PrintedDate",
		"Refunded",
		"Canceled",
		"PrintStatus",
		"AssetStatus",
		"ShippedStatus",
		
		// "products",
		// "DateTimeAfter",
		// "DateTimeBefore",
		// "components",
		// "Cost <",
		// "NewCheckbox",
		// "SomeSelectable"
	];

	//Make a copy of this array so we can use it for resets!
	var resetarray = Object.assign({}, priorityarray);

	var k = 0;
	var l = 0;
	var finalinputs = []; //Configure a variable to send to configuration!
	//If we have less than minimum inputs, we need to fill from priority array
	if (configuredinputs.length < minimuminputs +1) {
		for (var k = 0; k < configuredinputs.length; k++) {
			finalinputs.push(configuredinputs[k]);
			//Loop configured inputs and remove any priority items that are already handled!
			for (var m = 0; m < priorityarray.length; m++) {
				if (configuredinputs[k].type === priorityarray[m]) {
					priorityarray.splice(m, 1);
				}
			}
		}
	}

	//We can now itterate over the other priority inputs and fill in the next most important ones that weren't already sliced off the array.
	for (k = 0; k < priorityarray.length; k++) {
		// console.log("%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%");
		// console.log("Checking priority input: " + inputdefaults[priorityarray[k]].type);
		finalinputs.push(inputdefaults[priorityarray[k]]);
	}
	//Debug:
	// console.log("Final Inputs:");
	// console.log(finalinputs);

	//Save Final Inputs as Read-Only UseState:
	const [searchinputconfigurations, setSearchInputConfigurations] = useState(finalinputs);


	/* ##########################  Configuration  ########################## */
	//Perms - Be sure endpoints are secure because this certainly isn't. These are for perm driven views that child <FlexiGrid> will digest and use, not the perms on data.
	var perms = {
		createPerm: (userPerms['createOrder'] === 1 ? true : false),
		readPerm: (userPerms['readOrder'] === 1 ? true : false),
		updatePerm: (userPerms['updateOrder'] === 1 ? true : false),
		deletePerm: (userPerms['deleteOrder'] === 1 ? true : false),
	}


	//Grid Configuration
	const configuration = {
		//PAGE OPTIONS
		showtitle: true,
		title: "Order Manager",
		menuitem: "/ordersflexigrid",
		menusection: "Orders",
		viewmode:"grid", //Default is "grid" to show grid mode. 
		defaulteditmode:false,
		childcontroller:OrdersView,

		//DATA OPTIONS
		apiendpoint: "/flexigrid/",
		dbmodel: "flexorder", //or flexproduct, flexorder, etc	
		itemskey: "InternalID",
		nestedrelationships: [
			'creationuser', //CreatedByUserID
			'updateuser',	//UpdatedByUserID
			'deletionuser', //DeletedByUserID
			'validorderitems',
			'charges'
			//'product'
		],
		childitemurl: "/order/",
		mutatedata:MutateData,

		//DB Support items (try to add supports to DB tables when it's helpful)
		softdeletesupport: true,
		creationusersupport: true,
		updateusersupport: true,
		deleteusersupport: true,

		//Datetimes to handle
		datetimes: [
			'created_at',
			'updated_at',
			'OrderDate',
		],


		//TABLE OPTIONS
		tablebordertype: "thin", //open (no borders like on Products), thin (Main tables, darker border), thick (Order Details has all thick and lighter gray border tables)
		showcolumnheaders: true,
		maxrowseditmode: 100,
		statusbar: true,
		expandedrow: true,
		expandedrowrender: ExpandedRowRender, //Required function to be used inside expanded row <tr></tr> if ExpandRow=true
		minimuminputs: 4,
		maximuminputs: 8,
		rowsperpage: 100,
		rowsperpageoptions: [100, 250, 500],



		//Search Input Settings
		defaultselectinputs: [
			{value: "ordersquicksearch", text: "Quick Search" },
			{value: "OrderID", text: "Order Number" },
			{value: "ordersname", text: "Name" },
			{value: "products", text: "Products" },
			{value: "ordersproducttitle", text: "Product Title" },
			{value: "orderssku", text: "SKU" },
			{value: "markets", text: "Market" },
			{value:"Address", text:"Address"},
			{value:"City", text:"City"},
			{value:"StateCode", text:"Abbr State"},
			{value:"PostalCode", text:"ZIP"},
			{value:"Total >", text:"Total >"},
			{value:"Total <", text:"Total <"},
			{value:"OrderDateAfter", text:"Date After"},
			{value:"OrderDateBefore", text:"Date Before"},
			{value:"PrintedDate", text:"Print Date"},
			{value:"Refunded", text:"Refunded"},
			{value:"Canceled", text:"Canceled"},
			{value:"PrintStatus", text:"Printed"},
			{value:"AssetStatus", text:"Assets"},
			{value:"ShippedStatus", text:"Shipped"},
		],


		//Keep a copy of the default inputs just in case the user wants to "reset" the page
		inputdefaults: inputdefaults,
		resetarray: resetarray,
		//Controller will use your configured inputs
		configuredinputs: searchinputconfigurations,

		//Search by & order
		orderby: "OrderDate",
		order: "desc",

		//Columns describe the renderable columns
		//Header styles only respect width and not maxWidth or minWidth because tableLayout:"fixed" on flexigrid. Set these carefully, and minimally on what you can.
		columns: [
			{
				field: "Checkbox",
				visible: true,
				columnheader: "maincheckbox",
				columnheaderstyle: { width: "100px" }, //Raw inline css
				currentlyeditable: true,
				render: "maincheckbox", //Special, does not need extended config
				borders: "all",
				columnoption: false,
				columnoptionlabel: "Checkbox"

			},
			{
				field: "OrderDate",
				visible: true,
				columnheader: "text", //Requires columnheadertext and allowsort
				columnheadertext: "Order Date",
				columnheaderalign: "left", //left, right, center
				columnheaderstyle: { width: "145px" }, //Raw inline css
				valuetextalign: "left",
				allowsort: true,
				defaultsortorder: "desc",
				editable: true,
				requiresref: false,
				render: "datetime",
				datetimeformat: "short", //"friendly",
				borders: "all",
				columnoption: true,
				columnoptionlabel: "Order Date"
			},
			{
				field: "OrderID", // or "key" or "name"
				visible: true,
				columnheader: "text",
				columnheadertext: "Order Number",
				columnheaderalign: "left", //left, right, center
				columnheaderstyle: { width: "120px" }, //Raw inline css
				columnheadermaxwidth: "160px",
				valuetextalign: "left",
				allowsort: false,
				defaultsortorder: "asc",
				editable: false,
				requiresref: false,
				validationmethod: "text", // "text"....
				maxlength: 10, //Validation....
				render: "textlink", // "textlink", Requires linkid (used as value in url), target, and linkendpoint
				linkid: "InternalID",
				linkendpoint: "/order/",
				linkmaxwidth: "160px",
				target: "_blank",
				borders: "all",
				columnoption: false,
				columnoptionlabel: "Order Number"
			},
			{
				field: "MarketIcon",
				visible: true,
				columnheader: "text", //Requires columnheadertext and allowsort
				columnheadertext: "Mkt",
				columnheaderalign: "center", //left, right, center
				columnheaderstyle: { width: "34px" }, //Raw inline css
				valuetextalign: "center", //This can help also anchor any children, even buttons
				allowsort: false,
				defaultsortorder: "asc",
				editable: false,
				requiresref: false,
				render: "customelement",
				customelement: MktIcon,
				borders: "all",
				columnoption: true,
				columnoptionlabel: "Market"
			},
			{
				field: "Name", // or "key" or "name"
				visible: true,
				columnheader: "text",
				columnheadertext: "Name",
				columnheaderalign: "left", //left, right, center
				columnheaderstyle: { width: "160px" }, //Raw inline css
				valuetextalign: "left",
				allowsort: false,
				defaultsortorder: "asc",
				editable: false,
				requiresref: false,
				validationmethod: "text", // "text"....
				maxlength: 10, //Validation....
				render: "customelement",
				customelement: customNameElement,
				linkid: "ID",
				linkendpoint: "/boilerplatekeyvalues/",
				target: "_blank",
				borders: "all",
				columnoption: true,
				columnoptionlabel: "Name"
			},
			{
				field: "Items",
				visible: true,
				columnheader: "text",
				columnheadertext: "Items",
				columnheaderalign: "left", //left, right, center
				columnheaderstyle: {}, //Raw inline css
				valuetextalign: "left",
				allowsort: false,
				defaultsortorder: "asc",
				editable: false,
				requiresref: false,
				validationmethod: "text", // "text"....
				maxlength: 10, //Validation....
				render: "customelement",
				customelement: customItemsElement,
				borders: "all",
				columnoption: true,
				columnoptionlabel: "Items"
			},
			{
				field: "Total", // or "key" or "name"
				visible: true,
				columnheader: "text",
				columnheadertext: "Total",
				columnheaderalign: "right", //left, right, center
				columnheaderstyle: { width: "70px" }, //Raw inline css
				valuetextalign: "right",
				allowsort: true,
				defaultsortorder: "asc",
				editable: false,
				requiresref: false,
				validationmethod: "text", // "text"....
				maxlength: 10, //Validation....
				render: "text", // "textlink", Requires linkid (used as value in url), target, and linkendpoint
				linkid: "InternalID",
				linkendpoint: "/order/",
				target: "_blank",
				borders: "all",
				columnoption: true,
				columnoptionlabel: "Order Number"
			},
			{
				field: "PAS",
				visible: true,
				columnheader: "text", //Requires columnheadertext and allowsort
				columnheadertext: "PAS",
				columnheaderalign: "center", //left, right, center
				columnheaderstyle: { width: "100px" }, //Raw inline css
				valuetextalign: "center", //This can help also anchor any children, even buttons
				allowsort: true,
				defaultsortorder: "asc",
				editable: false,
				requiresref: false,
				render: "customelement",
				customelement: PASStatusRender,
				borders: "all",
				columnoption: true,
				columnoptionlabel: "PAS Status"
			},
		],

		//Controls how edit mode will traverse editable cells.
		//taborder: ["Cost", "PositiveInteger"],
		taborder: [],


		buttons: [
			{
				type: "Save",
				text: "Save",
				visible: true,
				perm: (userPerms['updateOrder'] === 1 ? true : false)
			}, {
				type: "PendingSave",
				text: "Save",
				visible: true,
				perm: (userPerms['updateOrder'] === 1 ? true : false)
			}, {
				type: "AddRow",
				text: "Add Row",
				visible: false,
				perm: (userPerms['createOrder'] === 1 ? true : false)
			}, {
				type: "AddItem",
				text: "Create Order",
				visible: true,
				perm: (userPerms['createOrder'] === 1 ? true : false)
			}, {
				type: "ViewOptions",
				text: "View Options",
				visible: true,
				perm: true,
				config: {
					expandsearch: true,
					expandall: true,
					editmode: false
				}
			}, {
				type: "EditItems",
				text: "Edit Items",
				visible: true,
				perm: (userPerms['updateOrder'] === 1 ? true : false)
			}, {
				type: "Export",
				text: "Export",
				visible: true,
				perm: true
			}, {
				type: "ItemList",
				text: "Order List",
				visible: true,
				perm: true,
				title: "Order List",
				description: "Filter grid results by Order Number.",
				itemlistkey: "OrderID"
			}, {
				type: "Reset",
				text: "Reset",
				visible: true,
				perm: true
			},
			// SPECIAL PURPOSE BUTTONS, YOU MAY CONFIGURE THESE FOR YOUR NEEDS INCLUDING FUNCTIONS!
			// Name them as such: CustomButton1, CustomButton2, etc.
			{
				type:"CustomButton1",
				text:"Select Unprinted",
				visible:true,
				perm:true,
				icon:false,
				customfunction: SelectUnprinted
			},
			{
				type:"CustomButton2",
				text:"View Worksheets",
				visible:true,
				perm:true,
				icon:false,
				requiresselection:true,
				customfunction: ViewSelectedWorksheets
			}
		],

		bulkeditcolumns: [
			{
				field: "PrintStatus",
				label: "Print Status",
				changetype: "customselect",
				customoptions: [
					<MenuItem value={0}>
						<div style={{ borderRadius: "5px", color: "#FFF", backgroundColor: "#CCC", padding: "2px 5px 0px 5px" }}>Not Printed</div>
					</MenuItem>,
					<MenuItem value={2}>
						<div style={{ borderRadius: "5px", color: "#FFF", backgroundColor: "#45b84a", padding: "2px 5px 0px 5px" }}>Printed</div>
					</MenuItem>
				],
				defaultvalue: false,
			},
			{
				field: "ShippedStatus",
				label: "Shipped Status",
				changetype: "customselect",
				customoptions: [
					<MenuItem value={0}>
						<div style={{ borderRadius: "5px", color: "#FFF", backgroundColor: "#CCC", padding: "2px 5px 0px 5px" }}>Not Shipped</div>
					</MenuItem>,
					<MenuItem value={2}>
						<div style={{ borderRadius: "5px", color: "#FFF", backgroundColor: "#45b84a", padding: "2px 5px 0px 5px" }}>Shipped</div>
					</MenuItem>
				],
				defaultvalue: false,
			},
		],

		exportoptions: {
			limit: 10000,
			exportmessage: "Exports of search results will be limited to your selection or the first " + 10000 + " rows of your current search.",
			filename: "OrdersCSV",
			columns: [
				{ column: "OrderID", label: "OrderID" },
				{ column: "OrderDate", label: "OrderDate", dateFormat: "YYYY-MM-DD HH:mm" },
				{ column: "Store", label: "Store" },
				{ column: "Name", label: "Name" },
				{ column: "Total", label: "Total" },
				{ column: "TaxTotal", label: "Tax Total" },
				//Shipping
				{ column: "SCompany", label: "SCompany" },
				{ column: "SLine1", label: "SLine1" },
				{ column: "SLine2", label: "SLine2" },
				{ column: "SLine3", label: "SLine3" },
				{ column: "SCity", label: "SCity" },
				{ column: "SStateCode", label: "SStateCode" },
				{ column: "SStateName", label: "SStateName" },
				{ column: "SPostalCode", label: "SPostalCode" },
				{ column: "SCountryCode", label: "SCountryCode" },
				{ column: "SCountryName", label: "SCountryName" },
				{ column: "SPhone", label: "SPhone" },
				{ column: "SEmail", label: "SEmail" },
				//Billing
				{ column: "BCompany", label: "BCompany" },
				{ column: "BLine1", label: "BLine1" },
				{ column: "BLine2", label: "BLine2" },
				{ column: "BLine3", label: "BLine3" },
				{ column: "BCity", label: "BCity" },
				{ column: "BStateCode", label: "BStateCode" },
				{ column: "BStateName", label: "BStateName" },
				{ column: "BPostalCode", label: "BPostalCode" },
				{ column: "BCountryCode", label: "BCountryCode" },
				{ column: "BCountryName", label: "BCountryName" },
				{ column: "BPhone", label: "BPhone" },
				{ column: "BEmail", label: "BEmail" },


				{ column: "Refunded", label: "Refunded" },
				{ column: "PrintedDate", label: "PrintedDate", dateFormat: "YYYY-MM-DD HH:mm" },
				{ column: "OrderStatus", label: "OrderStatus" },

				{ column: "Quantity", label: "Quantity" },
				{ column: "Sku", label: "Sku" },
				{ column: "ProductName", label: "Product Name" },
				{ column: "TotalPrice", label: "Sku Price" },

			],

			exporttypes: [
				{
					type: "Simple",
					mutatedata:null,
					removevalues: [ //REMEMBER THIS IS WHAT YOU DON'T WANT IN RESULTANT
						//Customer Data
						'SCompany',
						'SLine1',
						'SLine2',
						'SLine3',
						'SCity',
						'SStateCode',
						'SStateName',
						'SPostalCode',
						'SCountryCode',
						'SCountryName',
						'SPhone',
						'SEmail',

						'BCompany',
						'BLine1',
						'BLine2',
						'BLine3',
						'BCity',
						'BStateCode',
						'BStateName',
						'BPostalCode',
						'BCountryCode',
						'BCountryName',
						'BPhone',
						'BEmail',

						'Refunded',
						'PrintedDate',
					
						//These wont' work without mutation:
						'Quantity',
						'Sku',
						'ProductName',
						'TotalPrice',
					]
				},
				{
					type: "Expanded",
					mutatedata:null,
					removevalues: [
						//These wont' work without mutation:
						'Quantity',
						'Sku',
						'ProductName',
						'TotalPrice',
					]
				},
				{
					type: "Sales Tax",
					mutatedata:null,
					removevalues: [
						//No need to include all the sensitive data:
						//Customer Data
						'SCountryCode',
						'SCountryName',
						'SPhone',
						'SEmail',
						'SStateName',

						
						'BCountryCode',
						'BCountryName',
						'BPhone',
						'BEmail',
						'BStateName',

						'Refunded',
						'PrintedDate',
						'OrderStatus',
					
						//These wont' work without mutation:
						'Quantity',
						'Sku',
						'ProductName',
						'TotalPrice',
					]
				},
				{
					type: "Order Items",
					mutatedata:ExportMutateData,
					removevalues: [
						//Customer Data
						'SCompany',
						'SLine1',
						'SLine2',
						'SLine3',
						'SCity',
						'SStateCode',
						'SStateName',
						'SPostalCode',
						'SCountryCode',
						'SCountryName',
						'SPhone',
						'SEmail',

						'BCompany',
						'BLine1',
						'BLine2',
						'BLine3',
						'BCity',
						'BStateCode',
						'BStateName',
						'BPostalCode',
						'BCountryCode',
						'BCountryName',
						'BPhone',
						'BEmail',

						'Refunded',
						'PrintedDate',

						//These don't make sense on line-items if people are using sumations:
						'Total',
						'TaxTotal'

						// 'Quantity',
						// 'Sku',
						// 'ProductName',
						// 'TotalPrice'
						// 'TaxTotal'
					]
				}, 
			]
		}
	}





	/* 
				░█████████                               ░██                     
				░██     ░██                              ░██                     
				░██     ░██  ░███████  ░████████   ░████████  ░███████  ░██░████ 
				░█████████  ░██    ░██ ░██    ░██ ░██    ░██ ░██    ░██ ░███     
				░██   ░██   ░█████████ ░██    ░██ ░██    ░██ ░█████████ ░██      
				░██    ░██  ░██        ░██    ░██ ░██   ░███ ░██        ░██      
				░██     ░██  ░███████  ░██    ░██  ░█████░██  ░███████  ░██                                                                                                                 
	*/

	return (<FlexiGrid configuration={configuration} classes={classes} perms={perms} />);
}

export default OrdersFlexiGrid;